import(/* webpackMode: "eager" */ "/app/node_modules/bootstrap-icons/font/bootstrap-icons.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/bootstrap-italia/dist/css/bootstrap-italia.min.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Geist\",\"arguments\":[{\"variable\":\"--font-geist-sans\",\"subsets\":[\"latin\"]}],\"variableName\":\"geistSans\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Geist_Mono\",\"arguments\":[{\"variable\":\"--font-geist-mono\",\"subsets\":[\"latin\"]}],\"variableName\":\"geistMono\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Titillium_Web\",\"arguments\":[{\"variable\":\"--font-titillium\",\"subsets\":[\"latin\"],\"weight\":[\"400\",\"600\",\"700\"]}],\"variableName\":\"titillium\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Roboto_Mono\",\"arguments\":[{\"variable\":\"--font-roboto-mono\",\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"700\"]}],\"variableName\":\"robotoMono\"}");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/homepage.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/mobile-nav.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Consent/ConsentRoot.tsx");
